import { Input } from 'components/ui/input';
import React from 'react';

interface Iprops {
  fieldName: string;
  min: number;
  max: number;
  code: string;
  value: number;
  onChangeRange: (value: string) => void;
  onChangeInput: (value: string) => void;
}
const ConfigRange = ({
  fieldName,
  min,
  max,
  code,
  value,
  onChangeRange,
  onChangeInput,
}: Iprops) => {
  return (
    <>
      <p className="text-sm font-medium text-gray-blue-80 mb-1 flex my-2 items-center">
        {fieldName}
      </p>
      <span className="max-w-3xl flex my-2 items-center">
        <span className="text-sm font-normal text-gray-blue-80 mb-1 mr-1">0</span>
        <input
          type="range"
          id={`config-${code}-${fieldName}percent`}
          min={min}
          max={max}
          value={value || 1}
          style={{ accentColor: 'var(--color-green-400, #008053)' }}
          onChange={(e) => onChangeRange(e.currentTarget.value)}
          className="mx-2 w-3/4 h-0.5 text-green-400"
        />
        <span className="text-sm font-normal text-gray-blue-80 mb-1 ml-1 mr-2">100</span>

        <Input
          type="number"
          id={`config-${code}-${fieldName}Value`}
          value={value || 1}
          onChange={(e) => onChangeInput(e.currentTarget.value)}
          className="w-1/4 mx-2"
          min={min}
          max={max}
        />
      </span>
    </>
  );
};

export default ConfigRange;
